/**
 * SirenQ — Professional Scroll Animations v2.0
 * Alternating LEFT / RIGHT section entrances
 * Cards stagger one by one
 * Auto-applies to all current + future sections
 */

(function () {
  'use strict';

  /* ── CONFIG ──────────────────────────────────────────── */
  var CFG = {
    speed:   '0.70s',
    ease:    'cubic-bezier(0.22, 1, 0.36, 1)', /* smooth decelerate */
    dist:    '64px',
    stagger: 110,    /* ms between each card */
    threshold: 0.08, /* how much element must be visible before animating */
    rootMargin: '0px 0px -48px 0px'
  };

  /* ── INJECT CSS ──────────────────────────────────────── */
  var style = document.createElement('style');
  style.id = 'sq-anim-styles';
  style.textContent = '\
    .sq-rv {\
      opacity: 0;\
      will-change: opacity, transform;\
      transition:\
        opacity '   + CFG.speed + ' ' + CFG.ease + ',\
        transform ' + CFG.speed + ' ' + CFG.ease + ';\
    }\
    .sq-rv--left  { transform: translateX(-' + CFG.dist + '); }\
    .sq-rv--right { transform: translateX('  + CFG.dist + '); }\
    .sq-rv--up    { transform: translateY(40px); }\
    .sq-rv--fade  { transform: scale(0.97) translateY(20px); }\
    .sq-rv.sq-in  { opacity: 1 !important; transform: none !important; }\
    @media (prefers-reduced-motion: reduce) {\
      .sq-rv { opacity: 1; transform: none; transition: none; }\
    }\
  ';
  if (!document.getElementById('sq-anim-styles')) {
    document.head.appendChild(style);
  }

  /* ── HELPERS ─────────────────────────────────────────── */
  function mark(el, dir, delayMs) {
    if (!el || el.classList.contains('sq-rv')) return;
    el.classList.add('sq-rv', 'sq-rv--' + dir);
    if (delayMs) el.style.transitionDelay = delayMs + 'ms';
  }

  function markAll(els, dir) {
    Array.prototype.forEach.call(els, function (el, i) {
      mark(el, dir, i * CFG.stagger);
    });
  }

  /* ── SETUP PER SECTION ───────────────────────────────── */
  function setupSection(section, idx) {
    var isLeft = idx % 2 === 0; /* even = left, odd = right */
    var main  = isLeft ? 'left'  : 'right';
    var cross = isLeft ? 'right' : 'left';

    /* ── HERO: left content ← | right image → ── */
    mark(section.querySelector('.sirenq-hero__left'),   'left');
    mark(section.querySelector('.sirenq-hero__right'),  'right');
    mark(section.querySelector('.sq-mobile-cta'),       'up');

    /* ── STATS BAR: items stagger up ── */
    markAll(section.querySelectorAll('.sirenq-stats__item'), 'up');
    markAll(section.querySelectorAll('.sirenq-stats__divider'), 'fade');

    /* ── WAAROM AURI: text ← cards → (or reverse) ── */
    mark(section.querySelector('.swa-left'),  main);
    mark(section.querySelector('.swa-right'), cross);
    markAll(section.querySelectorAll('.swa-card'), 'up');

    /* ── ZO WERKT HET ── */
    mark(section.querySelector('.shw-header'), main);
    markAll(section.querySelectorAll('.shw-card'), 'up');
    mark(section.querySelector('.shw-btn-wrap'), 'up');

    /* ── FEATURE CARDS ── */
    mark(section.querySelector('.sfc-header'), main);
    markAll(section.querySelectorAll('.sfc-card'), 'up');
    mark(section.querySelector('.sfc-btn-wrap'), 'up');

    /* ── SCENARIOS ── */
    mark(section.querySelector('.ssc-header'), main);
    markAll(section.querySelectorAll('.ssc-card'), 'fade');

    /* ── FUTURE SECTIONS: gebruik data-sq of generic classes ── */
    /* Elk element met data-sq-dir="left|right|up|fade" attribuut */
    Array.prototype.forEach.call(
      section.querySelectorAll('[data-sq-dir]'),
      function (el, i) {
        var dir = el.getAttribute('data-sq-dir') || 'up';
        var delay = parseInt(el.getAttribute('data-sq-delay') || (i * CFG.stagger), 10);
        mark(el, dir, delay);
      }
    );

    /* Generic: .sq-animate-left / .sq-animate-right / .sq-animate-up */
    Array.prototype.forEach.call(
      section.querySelectorAll('.sq-animate-left'),
      function (el) { mark(el, 'left'); }
    );
    Array.prototype.forEach.call(
      section.querySelectorAll('.sq-animate-right'),
      function (el) { mark(el, 'right'); }
    );
    Array.prototype.forEach.call(
      section.querySelectorAll('.sq-animate-up'),
      function (el, i) { mark(el, 'up', i * CFG.stagger); }
    );
  }

  /* ── OBSERVER ────────────────────────────────────────── */
  var observer;

  function observe() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.sq-rv:not(.sq-in)'),
      function (el) { observer.observe(el); }
    );
  }

  /* ── INIT ────────────────────────────────────────────── */
  function init() {
    /* Reset existing marks if reinitialising */
    Array.prototype.forEach.call(
      document.querySelectorAll('.sq-rv'),
      function (el) {
        el.classList.remove('sq-rv', 'sq-rv--left', 'sq-rv--right',
                            'sq-rv--up', 'sq-rv--fade', 'sq-in');
        el.style.transitionDelay = '';
      }
    );

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sq-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold:  CFG.threshold,
      rootMargin: CFG.rootMargin
    });

    var sections = document.querySelectorAll('.sirenq-section');
    Array.prototype.forEach.call(sections, function (sec, idx) {
      setupSection(sec, idx);
    });

    observe();
  }

  /* ── BOOT ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── SHOPIFY THEME EDITOR: reinit on section load ─────── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 150);
    });
    document.addEventListener('shopify:section:reorder', function () {
      setTimeout(init, 150);
    });
  }

}());